import { apiGet } from '../../utilities/apiClient';
import { getSessionIds, getStoreState } from './_sessionIds';
import { ADD_RESPONSES, FETCHING_RESPONSES, FETCHED_RESPONSES } from '../constants';

/**
 * Fetch block responses for a project (same as web getResponses).
 * Used to pre-fill survey model with blob data per page; segments supplement for per-question.
 */
export const getResponses = (projectId: string | number, override = false) => async (dispatch: any) => {
  const { accountId, cognitoId } = getSessionIds();
  if (!accountId || !cognitoId) return { success: false };
  const pid = String(projectId);
  const state = getStoreState();
  const alreadyFetched = (state as any).responses?.fetched?.[pid];
  if (alreadyFetched && !override) return { success: true };

  dispatch({ type: FETCHING_RESPONSES, payload: true });
  try {
    const res = await apiGet(`/block-responses/get-all/${pid}/${accountId}/${cognitoId}`);
    if (res?.success && Array.isArray(res?.payload)) {
      dispatch({ type: ADD_RESPONSES, payload: { project_id: pid, list: res.payload } });
      dispatch({ type: FETCHED_RESPONSES, payload: { project_id: pid } });
      return { success: true, payload: res.payload };
    }
    dispatch({ type: FETCHED_RESPONSES, payload: { project_id: pid } });
    return { success: false };
  } catch (err: any) {
    dispatch({ type: FETCHED_RESPONSES, payload: { project_id: pid } });
    return { success: false, message: err?.message };
  } finally {
    dispatch({ type: FETCHING_RESPONSES, payload: false });
  }
};
